import { IEnergies } from '@app/@types/myEnergy'
import { Period } from '@app/lib/MyEnergy/intervalValues'
import * as type from '@app/constants/myEnergy/energyTab'

export const choosePeriod = (chosenPeriod: Period) => ({
  type: type.CHOOSE_PERIOD,
  chosenPeriod,
})

export const chooseSliderTab = (chosenTab: number) => ({
  type: type.CHOOSE_SLIDER_TAB,
  chosenTab,
})

export const updateEnergies = (energies: IEnergies) => ({
  type: type.UPDATE_ENERGIES,
  energies,
})

export const sync = () => ({
  type: type.SYNC_ENERGIES,
})
